import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import "./App.css";
import { Layout } from "./components/Layout";
import { ModalConfirmActionProvider } from "./components/Modals/ModalConfirmActionContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "./contexts/AuthContext";
import { Preloader } from "./components/Preloader";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ContractorsContextProvider } from "./contexts/ContractorsContext";

function App() {
  const { user } = useAuth();
  return (
    <div className="App dark:bg-neutral-700">
      <ThemeContextProvider>
        <DndProvider backend={HTML5Backend}>
          <ModalConfirmActionProvider>
            {user == null ? (
              <Preloader size={"3x"} className={"text-muted"} />
            ) : (
              <ContractorsContextProvider>
                <Layout />
              </ContractorsContextProvider>
            )}
          </ModalConfirmActionProvider>
        </DndProvider>
      </ThemeContextProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
